// extracted by mini-css-extract-plugin
module.exports = {"item":"GallariaItem_item__2zD_8"};